module.exports = __webpack_public_path__ + "@/assets/img/banner-mp.90159c84.png";